/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
define([
    'jQuery',
    'underscore',
    'library/fcse-widget/widget',
    'library/fcse-compatibility/object'],
        function($, _, Widget, Object) {

            var TagbarWidget = function(element, options) {
                Widget.apply(this, arguments);

                var defaultOptions = {
                    'selectedClassName': 'is-selected',
                    'emptyClassName': 'is-empty',
                    'deselectedClassName': 'is-hidden'
                };
                this.addOptions(defaultOptions, options);

                this._registerClickEvent();
            };

            TagbarWidget.prototype = $.extend(Object.create(Widget.prototype), {
                _registerClickEvent: function() {
                    var self = this;
                    $('[data-fcse-role="tagbar--remove"]', this.element).on("click", function(e) {
                        var $target = $(this).closest('[data-value]');
                        $target.addClass(self.option('deselectedClassName'));
                        $target.removeClass(self.option('selectedClassName'));
                        var value = [];
                        $('[data-value]', self.element).each(function(index, element){
                            if ($(element).hasClass(self.option('selectedClassName'))){
                                value.push($(element).attr('data-value'));
                            }
                        });

                        if (self.value !== value) {
                            self.setValue(value);
                        }
                        e.preventDefault();
                    });
                },
                setValueToUi: function() {
                    var self = this;
                    if ($.isArray(this.getValue())){
                        if (this.getValue().length == 0){
                            this.element.addClass(this.option('emptyClassName'));
                        } else {
                            this.element.removeClass(this.option('emptyClassName'));
                        }
                    }
                    $('[data-value]', this.element).removeClass(self.option('selectedClassName'));
                    $('[data-value]', this.element).addClass(self.option('deselectedClassName'));
                    _.each($('[data-value]', self.element), function(btn, index) {
                        var $btn = $(btn);
                        if ($.inArray($btn.attr('data-value'), self.value) !== -1) {
                            $btn.removeClass(self.option('deselectedClassName'));
                            $btn.addClass(self.option('selectedClassName'));
                        }
                    });
                },
                
               /**
                * Convert initial value
                * @param {type} data
                * @returns {Array}
                */
                _processData : function(data){
                    if ($.isArray(data)){
                        return data;
                    } else {
                        var initialData = $.parseJSON(data);
                        if (!$.isArray(initialData)){
                            return []; 
                        }
                    }
                }
            });

            return TagbarWidget;
        }
);


//////////////////
// WEBPACK FOOTER
// ./~/fcse-tagbarwidget/tagbarWidget.js
// module id = 183
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21